module.exports = __webpack_public_path__ + "img/beijing-2.10d45273.jpg";